webpackJsonp([29325821157970],{

/***/ 1352:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Should Your Employer Fund Your Education? Here’s How (and Why!) You Should Ask","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/should-your-employer-fund-your-education-heres-how-and-why-you-should-ask","createdAt":"2017-11-29T00:39:54.082Z","blogAuthor":{"fields":{"name":"Hugo Guerra","slug":"blog/author/hugo-guerra"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/5zWc74rMM8KCuesga0WEGo/7635107a3ede57c0387d7377133ac3be/blog-post-blog-should-your-employer-fund-your-education-heres-how-and-why-you-should-ask.jpg"}}}}}]},"authorJson":{"name":"Hugo Guerra","slug":"blog/author/hugo-guerra","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/hugo-guerra"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-hugo-guerra-87d3d56901e0fdda109e.js